// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/tab-item/tab-item.component.scss
// module id = 528
// module chunks = 0